import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';

export function QuoteDerogationLockNotice() {
  const { t } = useTranslation();

  return (
    <Alert variant="info">
      <InfoIcon />
      <div>
        <AlertTitle>{t('derogationLock.title')}</AlertTitle>
        <AlertDescription>{t('derogationLock.description')}</AlertDescription>
      </div>
    </Alert>
  );
}
